import { Button } from 'antd';
import { useTranslate } from '@tolgee/react';
import { formatNumber } from 'utils/numberFormat';
import dayjs from 'lib/dayjs';
import styled from '@emotion/styled';
import { ReturnOrderListItemV2 } from 'services/api/refund';
import DisputeModal from 'components/Refund/DisputeModal';
import posthog from '@leyan/lytics';
import useEvidenceModal from './EvidenceModal';
import { DisputeOperate } from 'services/api/return';
import useModal from 'hooks/useModal';
import { match } from 'ts-pattern';

const ProposeHistory = styled.div`
  background: var(--fett-erp-card-bg);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  > div {
    > span:first-child {
      margin-right: 8px;
      &:before {
        content: '';
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #d3d7e0;
        margin-right: 8px;
      }
    }
  }
`;

const BtnLookOphis = styled(Button)`
  margin-left: 2px;
  padding: 0;
`;

interface IProps {
  unit?: string;
  operationLog: Conversation.Trade.IReturnOperationLog[];
  row?: ReturnOrderListItemV2;
  externalTradeId?: string;
}

const OperationLogs = (props: IProps) => {
  const { operationLog, unit, row, externalTradeId } = props;
  const { t } = useTranslate();
  const [openEvidenceModal, evidenceModalInstance] = useEvidenceModal();

  const { visible: disputeVis, update: setDisputeVis, meta: visMeta } = useModal();
  return (
    <>
      {evidenceModalInstance}
      {operationLog.map((v, i) => {
        let money = '';
        let counterLimit = 3;
        let rawObj: any;
        try {
          rawObj = JSON.parse(v.raw);
          if (rawObj.refundAmount) {
            money = `${unit}${formatNumber(rawObj.refundAmount, '0,0.00')}`;
          }
          if (rawObj.counterLimit) {
            counterLimit = rawObj.counterLimit;
          }
        } catch (e) {
          posthog.capture('$returnRst', {
            custRreport: {
              opType: 'OperationLog',
              status: 'err',
              reqData: v.raw,
            },
          });
        }
        return (
          <ProposeHistory key={`his${v.operateTimeMs + i}`}>
            <div>
              <span>{v.userName}</span>
              {v.operate === 'SUBMIT_EVIDENCE' ? (
                <>
                  {t('trade.上传证据')}
                  <BtnLookOphis
                    type="link"
                    onClick={() =>
                      openEvidenceModal({
                        userName: v.userName,
                        operateTime: dayjs(Number(v.operateTimeMs)).format('YYYY-MM-DD HH:mm:ss'),
                        info: rawObj,
                      })
                    }
                  >
                    [{t('ViewRefund.checkEvidence')}]
                  </BtnLookOphis>
                </>
              ) : null}
              {v.operate === 'OFFER'
                ? `${counterLimit === 3 ? t('trade.提出部分退款') : t('trade.再次提案')} [${money}]`
                : null}
              {v.operate === 'ACCEPT_OFFER' ? `${t('trade.接受买家提案')} [${money}]` : null}
              {v.operate === 'FULL_REFUND' ? `${t('trade.全额退款')} [${money}]` : null}
              {v.operate === 'WAIT_RETURN' ? t('trade.等待退货') : null}
              {['DISPUTE', 'DISPUTE_TO_SHOPEE', 'PRE_DISPUTE', 'UPDATE_PRE_DISPUTE'].includes(
                v.operate,
              ) ? (
                <>
                  {match(v.operate)
                    .with('DISPUTE', () => {
                      return t('trade.争议');
                    })
                    .with('DISPUTE_TO_SHOPEE', () => {
                      return t('trade.向Shopee争议');
                    })
                    .with('PRE_DISPUTE', () => {
                      return t('预填写争议');
                    })
                    .with('UPDATE_PRE_DISPUTE', () => {
                      return t('修改预填写争议');
                    })
                    .otherwise(() => null)}
                  <BtnLookOphis
                    type="link"
                    disabled={!rawObj}
                    onClick={() => setDisputeVis(true, i)}
                  >
                    [{t('trade.查看争议')}]
                  </BtnLookOphis>
                  <DisputeModal
                    visible={disputeVis && visMeta === i}
                    setVisible={() => setDisputeVis(false)}
                    internalStoreId={row!.internalStoreId}
                    externalStoreId={row!.externalStoreId}
                    externalTradeId={externalTradeId!}
                    internalTradeId={`${row!.internalTradeId}`}
                    returnSn={row!.returnSn}
                    reqData={{
                      ...rawObj,
                      disputeReasonId: rawObj?.disputeReasonId
                        ? String(rawObj?.disputeReasonId)
                        : rawObj.disputeReason,
                    }}
                    disputeOperate={DisputeOperate.向shopee争议}
                  />
                </>
              ) : null}
              {v.operate === 'UNDO_PRE_DISPUTE' || v.operate === 'UNDO_DISPUTE'
                ? t('撤销争议')
                : null}
              {v.operate === 'CONFIRM' ? `${t('trade.接受')} [${money}]` : null}
              {v.operate === 'REFUSE' ? `${t('tableColumn.拒绝')}` : null}
              {v.operate === 'RETRACT_DISPUTE' ? t('trade.撤回争议') : null}
              {v.operate === 'MODIFY_PRICE' ? t('trade.修改出价') : null}
            </div>
            <span>{dayjs(Number(v.operateTimeMs)).format('YYYY-MM-DD HH:mm:ss')}</span>
          </ProposeHistory>
        );
      })}
    </>
  );
};

export default OperationLogs;
